import { createSelector } from 'reselect';
import { activeWorkflow } from '@/screens/workflows/redux/selectors/workflowScreenSelectors.js';
import { flattenGraphSequence } from '@shared/graph/flattenGraphSequence.js';
import memoizeSelector from '@/redux/lib/memoizeSelector.js';

const workflowGraph = createSelector([activeWorkflow], (workflow) => workflow?.graph);

const workflowSlimSteps = createSelector([activeWorkflow], (workflow) => {
  return workflow?.steps?.map?.((step) => {
    const { id, meta: { branches } = {}, message, stepNumber, options, arguments: args, ...rest } = step;
    return { id, meta: { branches }, message, stepNumber, ...rest };
  });
});

const actionStepsSelector = createSelector(
  [workflowGraph, workflowSlimSteps, (_, parentStepId) => parentStepId],
  memoizeSelector('actionStepsSelector', (graph, steps, parentStepId) => {
    return flattenGraphSequence(graph, steps, parentStepId).map((n) => ({
      ...n,
      stepNumber: steps?.find((s) => s.id === n.id)?.stepNumber,
      message: steps?.find((s) => s.id === n.id)?.message
    }));
  })
);

export default actionStepsSelector;
